import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import { withRouter } from "react-router";
import { Result, Button } from 'antd';

const NotFoundPage = (props) => {
	return(
		<PageTemplate>
			<Result
				status="404"
				title="페이지를 찾을 수 없습니다."
				extra={
					<Button 
						type="primary" 
						key="console"
						onClick={()=>props.history.push('/')}
					>
						메인페이지
					</Button>
				}
			/>
		</PageTemplate>
	);
};

export default withRouter(NotFoundPage);